import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ServicesMenuCloudguardIcon extends BaseIcon {
  getChildren = () => [
    <path fill="#e45785"
          d="M44.8 22h-30C6.6 22 0 28.7 0 37s6.6 15 14.8 15H21l1-1.5c2.6-3.9 6.1-7 10.2-9.2 3.9-2.1 8.2-3.3 12.6-3.4V22z"/>,
    <ellipse fill="#e45785" cx="30" cy="22" rx="14.8" ry="15"/>,
    <path fill="#3594ff"
          d="M32.2 41.2c2.1-1.1 4.3-2 6.6-2.6 4.7-1.2 9.6-1.2 14.2-.1 2.2.5 4.3 1.3 6.3 2.4.4-1.4.6-2.8.6-4.3-.2-8.3-7-14.8-15.1-14.6-7.9.2-14.2 6.6-14.4 14.6 0 1.7.3 3.4.9 5 .3 0 .6-.2.9-.4z"/>,
    <path fill="#3594ff"
          d="M45.8 52H24.2c2.4-3.5 5.5-6.4 9.2-8.3 1.9-1 3.9-1.8 6-2.3 4.2-1.1 8.7-1.1 12.9-.1 2 .5 3.9 1.2 5.8 2.2-.9 2.5-2.6 4.6-4.7 6.1-2.2 1.4-4.9 2.3-7.6 2.4z"/>,
    <path d="M30 37c8.2 0 14.8-6.7 14.8-15H15.2c0 8.3 6.6 15 14.8 15z" fill="#cc1e46"/>,
    <path
        d="M41.5 38.2l.4-.1c1-.1 1.9-.2 2.9-.3V22c-7.9.2-14.2 6.7-14.3 14.7 0 1.7.3 3.4.9 5 .3-.2.6-.3.9-.5 2.1-1.1 4.3-2 6.6-2.6.5-.1 1-.2 1.6-.3.2 0 .6-.1 1-.1z"
        fill="#303385"/>,
    <path d="M44.8 22c-7.9.2-14.2 6.7-14.3 14.7v.2c7.9-.2 14.2-6.8 14.3-14.9z" fill="#2b1246"/>
    ]
    getViewBox = () => '0 0 60 60'
}
